import {
    SHOW_WORK_ORDERS_LIST_VIEW,
    SET_WORK_ORDERS_PARAMS,
    WORK_ORDERS_RECEIVED,
    CREATE_WORK_ORDER,
    GET_WORK_ORDERS,
    UPDATE_WORK_ORDER_STATUS,
    SELECTED_WORD_ORDER_IDS,
    TOGGLE_WORK_ORDER_ACTION_PERFORMED,
    DELETE_WORK_ORDERS,
    GET_WORK_ORDERS_TABLE_FILTERS,
    RECEIVED_WORK_ORDERS_TABLE_FILTERS,
    ADD_COMMENT_TO_WORK_ORDER,
    ShowWorkOrderListViewAction,
    SetWorkOrdersParamsAction,
    WorkOrdersReceivedAction,
    CreateWorkOrderAction,
    GetWorkOrdersAction,
    UpdateWorkOrderStatusAction,
    SetSelectedWordOrderIdsAction,
    DeleteWorkOrdersAction,
    ReceivedWorkOrdersTableFiltersAction,
    AddCommentToWorkOrderAction,
    SELECTED_WORK_ORDER_COLUMNS,
    SelectedWorkOrderColumnsAction
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const showWorkOrderListView = createAction<ShowWorkOrderListViewAction["payload"]>(
    SHOW_WORK_ORDERS_LIST_VIEW
);

export const setWorkOrdersParams =
    createAction<SetWorkOrdersParamsAction["payload"]>(SET_WORK_ORDERS_PARAMS);

export const workOrdersReceived =
    createAction<WorkOrdersReceivedAction["payload"]>(WORK_ORDERS_RECEIVED);

export const createWorkOrder = createAction<CreateWorkOrderAction["payload"]>(CREATE_WORK_ORDER);

export const getWorkOrders = createAction<GetWorkOrdersAction["payload"]>(GET_WORK_ORDERS);

export const updateWorkOrderStatus =
    createAction<UpdateWorkOrderStatusAction["payload"]>(UPDATE_WORK_ORDER_STATUS);

export const setSelectedWorkOrderIds =
    createAction<SetSelectedWordOrderIdsAction["payload"]>(SELECTED_WORD_ORDER_IDS);

export const toggleWorkOrderActionPerformed = createAction(TOGGLE_WORK_ORDER_ACTION_PERFORMED);

export const deleteWorkOrder = createAction<DeleteWorkOrdersAction["payload"]>(DELETE_WORK_ORDERS);

export const getWorkOrdersTableFilters = createAction(GET_WORK_ORDERS_TABLE_FILTERS);

export const receivedWorkOrdersTableFilters = createAction<
    ReceivedWorkOrdersTableFiltersAction["payload"]
>(RECEIVED_WORK_ORDERS_TABLE_FILTERS);

export const addCommentToWorkOrder =
    createAction<AddCommentToWorkOrderAction["payload"]>(ADD_COMMENT_TO_WORK_ORDER);

export const setSelectedWorkOrderColumns = createAction<SelectedWorkOrderColumnsAction["payload"]>(
    SELECTED_WORK_ORDER_COLUMNS
);
